import React, { useEffect, useState } from "react";
import constants from "constants/index";
import Slider from "react-slick";
// import Video from "components/Video";

const PCDetailSlider = ({ obj, className }) => {
    const [imageSize, setImageSize] = useState("w=650&ar=2:1.2&fit=crop");

    useEffect(() => {
        const size =
            obj && obj.length === 1 && window.outerWidth >= 992
                ? `w=${window.outerWidth}`
                : obj && obj.length === 2 && window.outerWidth >= 992
                    ? `w=${window.outerWidth / 2}`
                    : window.outerWidth >= 992
                        ? "w=650&ar=2:1.2&fit=crop"
                        : window.outerWidth <= 768
                            ? "w=768&ar=2:1.1&fit=crop"
                            : window.outerWidth;
        setImageSize(size);
    }, []);

    let settings;
    if (obj && obj.length > 3) {
        settings = constants.propertyGallerySliderSetting;
    } else if (obj && obj.length === 1) {
        settings = {
            ...constants.propertyGallerySliderSetting,
            slidesToShow: 1,
            autoplay: false,
        };
    } else if (obj && obj.length === 2) {
        settings = {
            ...constants.propertyGallerySliderSetting,
            slidesToShow: 2,
            autoplay: false,
        };
    } else {
        settings = {
            ...constants.propertyGallerySliderSetting,
            autoplay: false,
        };
    }

    return (
        <Slider {...settings} className={`top-slider ${className}`}>
            {obj.map(({ list }, imageIndex) => {
                return (
                    list &&
                    list.path && (
                        <div key={imageIndex} className={`img__full-width ${obj.length === 1 ? "single-obj" : ""}`}>
                            <img src={`${list.path}?${imageSize}`} alt="product" />
                        </div>
                    )
                    // :
                    // <div key={imageIndex} className={`img__full-width ${obj.length === 1 ? 'single-obj' : ''}`}>
                    //     <Video
                    //         className="product-detail-video"
                    //         // videoImage={`${list.path}?${imageSize}`}
                    //         isControls={false}
                    //         isHoveringControls={false}
                    //         autoPlay={!isApp}
                    //         loop={true}
                    //         muted={true}
                    //         videoUrl={`${list.path}?${imageSize}`}
                    //     />
                    // </div>
                );
            })}
        </Slider>
    );
};

export default PCDetailSlider;
